import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
} from 'antd';

import moment from 'moment';
import {
  formatCell,
  getURLParams,
  createColumns,
  sorter,
} from '../../../helpers';

import { Filters } from '../../../containers/Filters';
import DataTable from '../../../containers/DataTable';
import Graph from '../../Graph';
import { Spinner } from '../../UI';
import Charts from '../../Charts';

const { Title } = Typography;

class Clicks extends PureComponent {
  state = {
    filters: {
      dt1: '',
      dt2: '',
      aff: '',
      saff: '',
      timeZone: '',
    },
    sevenDaysAgo: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    today: moment(new Date()).format('YYYY-MM-DD'),
  };

  componentDidMount () {
    const params  = getURLParams(window.location);
    const {
      dt,
      dt1,
      dt2,
      aff,
      saff,
    } = params;

    this.props.fetchUserInfo(() => {
      const payload = {
        dt1: dt ? dt : dt1 ? dt1 : this.state.sevenDaysAgo,
        dt2: dt ? dt : dt2 ? dt2 : this.state.today,
        aff: aff ? aff : '',
        saff: saff ? saff : '',
        timeZone: this.props.user.time_zone,
      };

      this.setState((state) => {
        return {
          filters: {
            ...state.filters,
            dt1: payload.dt1,
            dt2: payload.dt2,
            aff: payload.aff,
            saff: payload.saff,
            timeZone: payload.timeZone,
          }
        };
      });

      if (saff || aff) {
        this.props.fetchSaffList(payload);
      }

      this.props.fetchClickStats(payload);
    });
  };

  handleChange = (date, dateString) => {
    const [dt1, dt2] = dateString;

    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          dt1,
          dt2
        }
      };
    });

    const payload = {
      ...this.state.filters,
      dt1,
      dt2,
    };

    if (this.state.filters.aff) {
      this.props.fetchSaffList(payload);
    }

    this.handleChangeFilter(payload);
  };

  handleSelect = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          aff: value,
          saff: !!value ? state.filters.saff : '',
        }
      };
    });

    const payload = {
      ...this.state.filters,
      aff: value,
      saff: !!value ? this.state.filters.saff : '',
    };

    if (value) {
      this.props.fetchSaffList(payload);
    }

    this.handleChangeFilter(payload);
  };

  handleSaff = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          saff: value,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      saff: value,
    };

    this.handleChangeFilter(payload);
  };

  handleChangeFilter = (payload) => {
    this.props.history.push({ search: '' });
    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
    this.props.fetchClickStats(payload);
  };

  handleTab = (tabKey) => {
    const payload = {
      ...this.state.filters
    };

    this.props.fetchClickStats(payload);

    this.setState({
      tabKey
    });
  };

  update = () => {
    this.props.fetchClickStats(this.state.filters);
  };

  render() {
    const {
      pageLoading,
      loading,
      clickStats,
      clickStats: {
        fields,
        data,
        tableName
      }
    } = this.props;
    const fieldsObj = fields && fields[0];
    const params  = getURLParams(window.location);
    const { dt1, dt2 } = params;
    const dateFormat = 'YYYY-MM-DD';

    const renderTableCell = (text, record, item) => formatCell(item, text);

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
    );

    const chartContent = <Graph
      data={data}
      bars={[
        {
          fill: '#2196f3',
          dataKey: 'cnt',
          name: 'Amount',
          tooltipOptions: [
            { id: 2, shortName: 'perc', name: 'Percent', suffix: '%' },
          ]
        },
      ]}
      XAxisDataKey="status"
      tickXAxis={true}
      showLegend={false}
    />;

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <Filters
            defaultDate={[
              dt1 ? moment(dt1, dateFormat) : moment(),
              dt2 ? moment(dt2, dateFormat) : moment()
            ]}
            handleSelect={this.handleSelect}
            handleSaff={this.handleSaff}
            handleChange={this.handleChange}
          />
          <Charts
            graph={data}
            loading={loading}
            content={chartContent}
          />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: clickStats,
              tableName: tableName,
              toolbar: {
                titleExport: 'Filtered Clicks Export',
              }
            }}
            update={this.update}
          />
        </>
      );
    }

    return (
      <div>
        <Title>Filtered Clicks</Title>
        {content}
      </div>
    );
  }
}

Clicks.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  clickStats: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchSaffList: PropTypes.func.isRequired,
  fetchClickStats: PropTypes.func.isRequired,
};

export default Clicks;
